import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const PurchaseControlTotals = {
  type: 'MinMaxCalculationParametersInput',
  formTitle: 'Purchase Control Totals',
  formUrl: '/Suppliers/ControlTotals',
  screenReference: 'SUPPLIER_CONTROLTOTALS',
  operations: ALLOW_EDIT,
};

export default PurchaseControlTotals;
